import React, { useEffect, useState } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';
import cn from 'classnames';
import { APP_CONFIG } from '@constants';
import { flowType } from '@utility/userInfo';
import { LABEL } from '../../veriables';
import style from './CardEntry.module.scss';
import { TouchableDiv, TouchableButton } from '@components/common/Touchable';
import ModalHeader from '../../components/common/ModalHeader/index';

const Cardactivation = props => {
  // Props Destructuring

  const {
    OnProcess,
    swiped,
    tab,
    setTab,
    sendAndActivate,
    loading,
    checkBalance,
    serverAppTheme,
    seat,
    menuItemsHashTable,
    auth,
    orderingPortraitOrientation
  } = props;

  // State Management

  const [cards, setCards] = useState(null);

  // React Hooks

  useEffect(() => {
    if (seat?.cards?.length > 0) {
      let data = seat.cards;
      setCards(data);
    }
  }, [tab]);

  // Methods

  const getStatus = status => {
    switch (status) {
      case 0:
        return 'Pending';
        break;
      case 5:
        return 'Complete';
        break;
      case 9:
        return 'Error';
        break;
    }
  };

  const getActivateGameCards = () => {
    let items = seat?.orders[0]?.items;
    let data = [];
    items?.forEach(i => {
      if (i.pending && !JSON.parse(i.orderJson).isLinked) {
        if (
          menuItemsHashTable[JSON.parse(i.orderJson).menuItemId]?.cardType === 1
        ) {
          data.push(i);
        }
      } else if (i.pending && JSON.parse(i.orderJson).isLinked) {
        let present = data.some(
          item =>
            JSON.parse(item.orderJson).uniqueIdForLinkedItem ==
            JSON.parse(i.orderJson).uniqueIdForLinkedItem
        );
        if (!present) {
          if (
            menuItemsHashTable[JSON.parse(i.orderJson).menuItemId]?.cardType ==
            1
          ) {
            data.push(i);
          }
        }
      }
    });
    return data;
  };

  const getNames = i => {
    let items = i;
    let names = { name: '', modifiers: [] };
    names.name =
      menuItemsHashTable[JSON.parse(items?.orderJson).menuItemId]?.name;
    const modifiersBasedOnLinkedItem =
      JSON.parse(items?.orderJson)?.modifierJson &&
      JSON.parse(JSON.parse(items?.orderJson)?.modifierJson)?.hasLinkedMenuItem
        ? JSON.parse(JSON.parse(items?.orderJson)?.modifierJson)?.modifiers
        : JSON.parse(items?.orderJson)?.modifiers;
    let a = [];
    modifiersBasedOnLinkedItem.forEach(i => {
      a.push(i.modifierName);
    });
    names.modifiers = a;
    return names;
  };

  const getCardNumber = id => {
    const keyValueObject = swiped.reduce((acc, item) => {
      let a = {
        cardNumber: item.cardNumber,
        entryMethod: item.entryMethod,
        cardId: item.cardId,
        displayCardNumber: item.displayCardNumber,
      };
      acc[item.checkOrderItemId] = a;
      return acc;
    }, {});
    return keyValueObject[id + '']?.displayCardNumber;
  };

  const getSwipeBtnDisable = () => {
    return (
      auth?.gamingSystemConfig?.entryMethods === null ||
      auth?.gamingSystemConfig?.entryMethods.length == 0 ||
      (auth?.gamingSystemConfig?.entryMethods.length > 0 &&
        auth?.gamingSystemConfig?.entryMethods.includes(''))
    );
  };

  // HTML CSS Code

  return (
    <div
      style={{
        backgroundColor: serverAppTheme.popUp_bg,
        border: serverAppTheme?.popupBorder,
        boxShadow: serverAppTheme?.popUp_box_shadow,
        color: serverAppTheme?.primary_text,
      }}
      className={cn(
        'col-12 col-md-12 px-0 mx-0 h-100 rowReverse position-relative'
      )}
    >
      {loading && <Loader />}
      <ModalHeader
        isTab={props.seat?.tab}
        stationName={props.seat?.stationName}
        tileHeader="Game Card"
        seatNumber={props.seat?.number}
      />
      <div
        className={cn(
          'col-12 px-2 fs_18  fw-600 d-flex align-items-center justify-content-center',orderingPortraitOrientation ? 'py-3 ' : 'h-10 '
        )}
      >
        {LABEL().GAME_CARD_SWIPE_TO_ACTIVATE}
      </div>
      <div className={cn('col-12  py-1 d-flex ' ,orderingPortraitOrientation ? 'h-6 px-3' : 'h-10 px-1')}>
        <div className={cn('col-12 px-0 h-100 d-flex')}>
          <TouchableDiv
            className={cn(
              'col-6 px-0 h-100 d-flex justify-content-center align-items-center rounded-left',
              style.tabsBorder
            )}
            style={{
              background: !tab ? serverAppTheme?.selected : 'transparent',
              color: !tab ? 'black' : serverAppTheme?.primary_text,
              fontWeight: !tab ? '500' : '400',
              fontSize : orderingPortraitOrientation ? '20px' : '',
              outline: 'none',
            }}
            tabIndex="0"
            role="button"
            onClick={e => {
              e.preventDefault();
              setTab(false);
            }}
            rippleEffect={true}
          >
            {LABEL().PENDING}
          </TouchableDiv>
          <TouchableDiv
            className={cn(
              'col-6 px-0 h-100 d-flex justify-content-center align-items-center rounded-right',
              style.tabsBorder
            )}
            style={{
              background: tab ? serverAppTheme?.selected : 'transparent',
              color: tab ? 'black' : serverAppTheme?.primary_text,
              fontWeight: tab ? '500' : '400',
               fontSize : orderingPortraitOrientation ? '20px' : '',
              outline: 'none',
            }}
            tabIndex="0"
            role="button"
            onClick={e => {
              e.preventDefault();
              setTab(true);
            }}
            rippleEffect={true}
          >
            {LABEL().PROCESS}
          </TouchableDiv>
        </div>
      </div>
      <div
        className={cn('px-0  overflowY' , orderingPortraitOrientation ? `${style.containermargin} mt-3` : 'mx-2 mt-10')}
        // tab ? 'h-78' : 'h-55'
        // maxHeight: tab ? '75%' : '55%'
        style={{
          border: serverAppTheme?.gameCard_table_border,
          borderRadius: '4px',
          maxHeight: tab ? (orderingPortraitOrientation ? '70%' : '75%') : '55%',
          overflowX : orderingPortraitOrientation ? 'hidden' : ''
        }}
      >
        {tab ? (
          <table className={cn('w-100')}>
            <tr
              style={{ borderBottom: serverAppTheme?.gameCard_table_border }}
              className="text-center px-3"
            >
              <th className={cn('w-20 text-left p-1 fw-normal  pl-3', orderingPortraitOrientation ? 'fs_12' : 'fs_14')}>
                {LABEL().NAME}
              </th>
              <th className={cn('w-20 text-left py-1 fw-normal', orderingPortraitOrientation ? 'fs_12 pl-2' : 'fs_14')}>
                {LABEL().NUMBER}
              </th>
              <th className={cn('w-15 text-left p-1 fw-normal',orderingPortraitOrientation ? 'fs_12' : 'fs_14')}>
                {LABEL().PRICE}
              </th>
              <th className={cn('w-10 text-left py-1 fw-normal',orderingPortraitOrientation ? 'fs_12 px-2' : 'fs_14')}>
                {LABEL().STATUS}
              </th>
              <th className={cn('w-35  p-1 fw-normal',orderingPortraitOrientation ? 'fs_12 text-center' : 'fs_14 text-left')}>
                {LABEL().MESSAGE}
              </th>
            </tr>
            {cards
              ?.filter(i => i?.type === 1)
              .map(item => {
                return (
                  <tr
                    key={1}
                    style={
                      item.status == 9
                        ? {
                            background: serverAppTheme?.gameCard_error_bg,
                            color: 'white',
                            borderBottom: serverAppTheme?.gameCard_table_border,
                          }
                        : {
                            borderBottom: serverAppTheme?.gameCard_table_border,
                          }
                    }
                    className="px-3"
                  >
                    <td className={cn('pl-3 py-2' ,orderingPortraitOrientation ? 'col-3 pr-1 fs_12 fw-500' : '')}>{item.name}</td>
                    <td className={cn("py-2",orderingPortraitOrientation ? 'col-4 pl-2  fs_12 fw-500' : '')}>{item.number}</td>
                    <td className={cn("py-2",orderingPortraitOrientation ? 'fs_12 fw-500' : '' )}>
                      {LABEL().CURRENCY_SYMBOL + item.amount.toFixed(2)}
                    </td>
                    <td
                      className={cn("py-2",orderingPortraitOrientation ? 'fs_12 pl-2 fw-500' : '')}
                      style={item.status == 9 ? { fontWeight: !orderingPortraitOrientation ? 'bold' : ''} : {}}
                    >
                      {getStatus(item.status)}
                    </td>
                    <td className={cn("py-2", orderingPortraitOrientation ? 'fs_12 fw-500' : '')}>{item.message}</td>
                  </tr>
                );
              })}
          </table>
        ) : (
          <>
            {' '}
            <table className={cn('w-100')}>
              <thead>
                <tr
                  style={{
                    borderBottom: serverAppTheme?.gameCard_table_border,
                  }}
                >
                  <th
                    className={cn('text-left py-1  fw-normal' , orderingPortraitOrientation ? 'col-4 px-4 fs_12' : 'fs_14')}
                    style={{ paddingLeft: !orderingPortraitOrientation ? '1.75rem' : ''}}
                  >
                    {LABEL().CARDNAME}
                  </th>
                  <th className={cn('text-left py-1 fw-normal',orderingPortraitOrientation ? 'col-4 px-1 fs_12' : 'fs_14')}>
                    {LABEL().CARDNUMBER}
                  </th>
                  <th className={cn('text-center py-1 fw-normal ',orderingPortraitOrientation ? 'col-3 px-4 fs_12' : 'pl-4 fs_14')}>
                    {LABEL().SELECT}
                  </th>
                </tr>
              </thead>
              <tbody
                className="overflowY"
                style={{ maxHeight: '200px', overflowY: 'auto' }}
              >
                {getActivateGameCards()?.map((item, index) => {
                  return (
                    <tr
                      style={{
                        borderBottom: serverAppTheme?.gameCard_table_border,
                        color: serverAppTheme?.primary_text,
                      }}
                      key={1}
                    >
                      <td
                        className={cn('py-2', orderingPortraitOrientation ?'col-4 px-4 fs_12 fw-500' : 'pr-1 fs_14 fw-normal')}
                        style={{ paddingLeft: !orderingPortraitOrientation ? '1.75rem' : '' }}
                      >
                        <div>
                          <div>{getNames(item).name}</div>
                          <div className="pl-2">
                            {' '}
                            {getNames(item).modifiers.map(i => {
                              return <div>{i}</div>;
                            })}
                          </div>
                        </div>
                      </td>
                      <td className={cn('px-1 py-2', orderingPortraitOrientation ? 'col-4 fs_12 fw-500' : 'fs_14 fw-normal')}>
                        {getCardNumber(item.id)}
                      </td>
                      <td
                        className={cn(
                          'pl-1 py-2 mt-1 d-flex justify-content-center align-items-start' ,orderingPortraitOrientation ? 'pr-4' : ''
                        )}
                      >
                        <div
                          className={cn(
                            'w-100 h-100 d-flex align-items-center justify-content-end',
                           !orderingPortraitOrientation ? 'pl-3' : ''
                          )}
                          style={{ paddingRight: !orderingPortraitOrientation ?  '1.75rem' : ''}}
                        >
                          <TouchableButton
                            disabled={getSwipeBtnDisable()}
                            style={{
                              height:orderingPortraitOrientation ? '4vh' : '7vh',
                              backgroundColor: getSwipeBtnDisable()
                                ? serverAppTheme.menu_btn_disable_bg
                                : serverAppTheme?.secondaryBtn,
                              color: getSwipeBtnDisable()
                                ? '#D7C9F6'
                                : serverAppTheme?.btn_font_color,
                            }}
                            type="submit"
                            className={cn(
                              'px-0 border-0 rounded btn-ripple fs_14 fw-normal d-flex justify-content-center align-items-center' , orderingPortraitOrientation ? 'col-12' :'col-10'
                            )}
                            onClick={e => {
                              e.preventDefault();
                              OnProcess(item);
                            }}
                            rippleEffect={true}
                          >
                            {LABEL().GAMECARDSWIPE}
                          </TouchableButton>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        )}
      </div>
      {!tab && (
        <div
          style={{ bottom: '1rem', left: 0 }}
          className={cn("w-100 d-flex align-items-end justify-content-between h-12 position-absolute" , orderingPortraitOrientation ? 'px-12' : 'px-2')}
        >
          <TouchableButton
            type="cancel"
            style={{
              width: '33%',
              backgroundColor: serverAppTheme?.OFF_Premise_Btn,
              border: serverAppTheme?.cancleBtn_Border,
              color: serverAppTheme?.cancleBtn_font,
              marginRight: "8px"
            }}
            className={cn(
              'px-0  fw-600 btn-ripple rounded d-flex justify-content-center align-items-center' , orderingPortraitOrientation ? 'btn68' : 'btn44'
            )}
            onClick={e => {
              e.preventDefault();
              props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
                replace: true,
              });
            }}
            rippleEffect={true}
          >
            {LABEL().CANCEL}
          </TouchableButton>
          <TouchableButton
            className={cn(
              'px-0 fw-600 btn-ripple rounded d-flex justify-content-center align-items-center',orderingPortraitOrientation ? 'btn68' : 'btn44'
            )}
            style={{
              width: '33%',
              border: serverAppTheme?.cancleBtn_Border,
              background: getSwipeBtnDisable()
                ? '#345388'
                : serverAppTheme?.OFF_Premise_Btn,
              color: getSwipeBtnDisable()
                ? serverAppTheme.secondary_btn_disable_text
                : serverAppTheme?.cancleBtn_font,
                marginRight: "8px",
            }}
            disabled={getSwipeBtnDisable()}
            type="submit"
            onClick={e => {
              e.preventDefault();
              checkBalance();
            }}
            rippleEffect={true}
          >
            {LABEL().BALANCE}
          </TouchableButton>
          <TouchableButton
            type="submit"
            style={{
              width: '33%',
              backgroundColor:
                getActivateGameCards().length == 0
                  ? serverAppTheme?.secondary_btn_disable
                  : serverAppTheme?.secondaryBtn,
              color:
                getActivateGameCards().length == 0
                  ? serverAppTheme?.secondary_btn_disable_text
                  : serverAppTheme?.btn_font_color,
              opacity: 1,
            }}
            className={cn(
              'px-0 fw-600 btn-ripple  border-0 rounded d-flex justify-content-center align-items-center',orderingPortraitOrientation ? `${style.btnText} btn68` : 'btn44'
            )}
            disabled={getActivateGameCards().length == 0}
            onClick={e => {
              e.preventDefault();
              sendAndActivate();
            }}
            rippleEffect={true}
          >
            {LABEL().SENDANDACTIVATE}
          </TouchableButton>
        </div>
      )}
      {tab && (
        <TouchableButton
          type="cancel"
          style={{
            width: orderingPortraitOrientation ? '56%' : '33%',
            backgroundColor: serverAppTheme?.OFF_Premise_Btn,
            border: serverAppTheme?.cancleBtn_Border,
            color: serverAppTheme?.cancleBtn_font,
            bottom: "16px",
            transform: orderingPortraitOrientation ? "translate(35% , 0)" : "translate(100%, 0)"
          }}
          className={cn(
            'px-0  fw-600 btn-ripple rounded d-flex justify-content-center align-items-center position-absolute', orderingPortraitOrientation ? 'btn68' : 'btn44'
          )}
          onClick={e => {
            e.preventDefault();
            props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
              replace: true,
            });
          }}
          rippleEffect={true}
        >
          {LABEL().BACK_TO_CHECKLIST}
        </TouchableButton>
      )}
    </div>
  );
};

export default Cardactivation;
